<template>
  <div>
    <p v-if="!$store.state.user.id">Please sign in to leave a comment.</p>

    <form v-else @submit.prevent>
      <MtxInput
        v-model="comment"
        :disabled="isLoading"
        type="textarea"
        label="Comment"
        class="mb-2"
      />
      <button :class="{ 'btn--disabled': $v.$invalid || isLoading }" @click="onSubmit">
        Submit
      </button>
    </form>
  </div>
</template>

<script>
import { required } from "@/utils/validators"
import API from "@/api"

export default {
  props: {
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    isLoading: false,
    comment: ""
  }),

  methods: {
    async onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid || this.isLoading) return

      this.isLoading = true

      const { success, data } = await API.postComment({
        content: this.comment,
        referenceType: this.referenceType,
        referenceId: this.referenceId
      })

      if (success) {
        this.$emit("success", data.comment)
        this.comment = ""
      }

      this.isLoading = false
    }
  },

  validations: {
    comment: {
      required
    }
  }
}
</script>

<style></style>
